/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import type { ThemeType } from "../../../../../global/emotion";
import { numericViewportWidth, spacing } from "../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../lib/constants/emotionMediaQueries.constants";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";

const asideStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
  height: spacing.full,
  left: 0,
  overflowX: "hidden",
  overflowY: "auto",
  paddingBottom: spacing.xxxl,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.m,
  position: "sticky",
  top: 64,
  width: spacing.full,
  [cssMediaQueryMinWidthTablet]: {
    maxHeight: `calc(100dvh - ${spacing.xxxl})`,
  },
};
const asideClosedStyle: Interpolation = {
  maxWidth: 72,
  minWidth: 72,
};
const asideExpandedStyle: Interpolation = {
  maxWidth: numericViewportWidth[100],
  minWidth: numericViewportWidth[100],
  [cssMediaQueryMinWidthTablet]: {
    maxWidth: spacing.sidebar,
    minWidth: spacing.sidebar,
  },
};
const borderStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.semanticColors.neutralsLowest,
  height: `calc(100% - ${spacing.xl})`,
  position: "absolute",
  right: 0,
  top: 0,
  width: spacing.t,
});
const containerStyle: Interpolation = {
  position: "relative",
};

export type SidebarProps = HallowElementProps<"aside"> & {
  borderCSS?: Interpolation;
  state?: "closed" | "expanded";
};

export const Sidebar = ({
  borderCSS = {},
  children,
  state = "expanded",
  ...props
}: SidebarProps) => {
  return (
    <div css={containerStyle}>
      <aside
        css={[
          asideStyle,
          state === "closed" ? asideClosedStyle : asideExpandedStyle,
        ]}
        {...props}
      >
        {children}
      </aside>
      <div css={[borderStyle, borderCSS]} />
    </div>
  );
};
